import {
  dailyDairyService,
} from "../../../../Api/Services/DailyDariyService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IGetDailyDairyServiceResponse } from "../../types";

export const fetchDailyDairySlots = createServiceAsyncThunk<
  IGetDailyDairyServiceResponse,
  { userId?: number; date?: string } // Response Typex
>(
  ACTION_NAMES.FETCH_DAILY_DAIRY_SLOTS, // Action name
  ({ userId, date }: { userId?: number; date?: string }) =>
    dailyDairyService.getDailyDairySlots(userId, date), // API Call
  ERROR_MESSAGES.FETCH_DAILY_DAIRY_SLOTS_FAILURE // Error Message
);

const dailyDairySlotsSlice = createGenericSlice<
  IGetDailyDairyServiceResponse,
  { userId?: number; date?: string }
>(
  SLICE_NAMES.DAILY_DAIRY_SLOTS_SLICE, //Slice Name
  fetchDailyDairySlots // Async Thunk
);

// Export actions to be used in components for resetting error and details
export const {
  clearError: clearDailyDairySlotsError,
  clearSuccessMessage: clearDailyDairySlotsSuccess,
} = dailyDairySlotsSlice.actions;

// Export the reducer to be included in the Redux store
export default dailyDairySlotsSlice.reducer;
